import { render, staticRenderFns } from "./TheBottomNavigation.vue?vue&type=template&id=17e2eca7&scoped=true&"
import script from "./TheBottomNavigation.vue?vue&type=script&lang=ts&"
export * from "./TheBottomNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e2eca7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBottomNavigation,VBtn})
